/*
 * Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { wbsColor } from "../SchufaCheckin/schufaCheckinStyles";

export const wbsTeaserWithCardsStyles = {
  teaser: {
    minHeight: "60vh",
    overflow: "hidden",
    backgroundPositionX: "center",
    backgroundPositionY: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-around",
    flexWrap: "wrap",
  },
  gridItemText: {
    textAlign: "center",
    marginBottom: "1rem",
  },
  gridContainer: {
    paddingBottom: "20px",
    marginTop: "3rem",
  },
  buttonContainer: {
    textAlign: "center",
  },
  startButton: {
    marginTop: "20px",
    width: { xs: "100%", sm: "40%" },
    color: "white",
    backgroundColor: wbsColor,
    "&:hover": { backgroundColor: wbsColor },
  },
};
